/**
 * @class
 * @typedef {{isFullscreen:Boolean,onClose:Function}} T.PopupModal.Par
 * @extends mkE.Base
 */
T.PopupModal = Class(
    /**
     * @lends {T.PopupModal#}
     */
    {
        /** @type {Boolean} */
        isFullscreen: false,
        /** @type {Function} */
        onClose: null,
        isClosed: true,
        /**
         * @param {T.PopupModal.Par} par
         * @private
         */
        __construct(par = {}) {
            this.isFullscreen = Boolean(par.isFullscreen || false);
            this.onClose = par.onClose || null;
            this.node = mkE({
                tag: 'div',
                className: 't_popup_modal',
                els: [
                    this.container = mkE({
                        tag: 'div',
                        className: 't_popup_modal__container',
                        style: {
                            // maxHeight: '0%'
                        },
                        els: [
                            this.content = mkE({
                                tag: 'div',
                                className: 't_popup_modal__content'
                            }),
                            {
                                tag: 'button',
                                className: 't_popup_modal__close',
                                onclick: this.close,
                                attr: {
                                    "arial-label": "Close"
                                },
                                els: [{tag:'div'}]
                            }
                        ]
                    })
                ]
            });
            if (this.isFullscreen) {
                mkE({
                    tag: 'div',
                    className: 't_popup_modal__trans',
                    onclick: this.close
                }).prepend(this.node);
                addClassName(this.node, 't_popup_modal--fs');
            }
        },
        setContent(els) {
            clearNode(this.content);
            mkE.appendTypeElement(this.content, els);
        },
        open() {
            if (this.isOpen()) {
                return;
            }
            this.isClosed = false;
            if (T.PopupModal.instance !== null && T.PopupModal.instance !== this) {
                T.PopupModal.instance.close();
            }
            T.PopupModal.instance = this;
            if (this.isFullscreen) {
                this.node.style.display = '';
            } else {
                removeClassName(this.container, 'animated');
                this.container.style.maxHeight = '0%';
                this.container.offsetHeight;
                requestAnimationFrame(() => {
                    addClassName(this.container, 'animated');
                    this.container.style.maxHeight = '100%';
                });
            }

        },
        close() {
            if (!this.isOpen()) {
                return;
            }
            this.isClosed = true;
            if (this.isFullscreen) {
                this.node.style.display = 'none';
            } else {
                removeClassName(this.container, 'animated');
                this.container.style.maxHeight = this.container.offsetHeight + 'px';
                requestAnimationFrame(() => {
                    addClassName(this.container, 'animated');
                    this.container.style.maxHeight = '0';
                });
            }
            if (this.onClose) {
                this.onClose();
            }
        },
        isOpen() {
            return !this.isClosed;

        }
    },
    mkE.Base
);

T.PopupModal.instance = null;